import { forwardRef } from 'react';
import { Container } from 'framework/chip/Container';
import { ChipExtendedProps } from 'framework/chip/types';
import { getChipColor, getChipFill, getIconColor } from 'framework/chip/utils';
import { Icon } from 'framework/Icon';
import { useThemeContext } from 'framework/theme/context/ThemeContext';

export const ChipStatus = forwardRef<HTMLButtonElement, ChipExtendedProps>(
  ({ label, ...rest }, ref) => {
    const { variant } = useThemeContext();
    const color = getChipColor(rest.variant, variant);
    const icon = getIconColor(rest.variant, variant);
    const theme = getChipFill(rest.variant, variant);

    return (
      <Container
        {...rest}
        ref={ref}
        theme={{ ...rest.theme, font: { color: { normal: color } }, chip: theme }}
      >
        <Icon
          icon={rest.icon}
          width="fit-content"
          size="11px"
          theme={{ normal: icon, hover: icon, focus: icon }}
          button
        />
        <span>{label}</span>
      </Container>
    );
  }
);

export const Chip = ({ label, ...rest }: ChipExtendedProps) => {
  const { variant } = useThemeContext();
  const icon = getIconColor(rest.variant, variant);

  return (
    <Container {...rest}>
      <Icon
        icon={rest.icon}
        width="fit-content"
        size="11px"
        theme={{ normal: icon, hover: icon, focus: icon }}
      />
      <span>{label}</span>
    </Container>
  );
};
